<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->

<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-th-list"></i>
        Main
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WFDetector</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Main</a>
          </li>
      </ul>
    </div>
    <template v-if="base">
      <b-card>

        <b-row>
          <b-col>
            <span>Real-time</span>
            <c-switch class="pt-2 ml-2" color="success" label variant="pill" v-model="sync.run" @change="refresh" />
            <span v-b-tooltip.hover title="can see the log real-time" v-if="auto_refresh != false">
              <select v-model="sync.interval" @change="refresh" :disabled="!sync.run">
                <option value="15">Default interval : 15</option>
                <option value=10>10</option>
                <option value=30>30</option>
                <option value=60>60</option>
                <option value=300>300(5 min)</option>
              </select>
              Sec
            </span>
          </b-col>
        </b-row>

      </b-card>
      <ListWSFinderResult v-show="list_wsfinder_result" ref="list_wsfinder_result" :is_main="true" :limit="20"/>
      <ListWMDSResult v-show="lsit_wmds_result" ref="list_wmds_result" :is_main="true" :limit="20"/>
    </template>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
